const DSGVO_de = `
# Datenschutzerklärung

## 1. Allgemeine Hinweise  
Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. Wir erheben auf dieser Webseite keine personenbezogenen Daten und bieten keine interaktiven Funktionen wie Formulare oder Benutzerkonten an.

## 2. Verantwortliche Stelle  
**Esther Ratsch und Jörg Schultz GbR**  
Am Mühlschutz 2  
97348 Rödelsee  
E-Mail: [Joerg.Schultz@tier-wohl-team.de](mailto:Joerg.Schultz@tier-wohl-team.de)

## 3. Hosting  
Diese Webseite wird auf Servern der **Amazon Web Services (AWS)** betrieben. AWS speichert automatisch Informationen in sogenannten Server-Log-Dateien, die Ihr Browser automatisch übermittelt (z. B. IP-Adresse, Zeitpunkt des Zugriffs). Diese Daten dienen ausschließlich der technischen Sicherheit und werden nicht mit anderen Datenquellen zusammengeführt.

## 4. Eingebettete Inhalte von Drittanbietern  
Auf unserer Webseite sind **YouTube-Videos** eingebettet. Beim Aufruf einer Seite mit eingebettetem Video kann YouTube Daten über Sie sammeln. Weitere Informationen hierzu finden Sie in der [Datenschutzerklärung von Google](https://policies.google.com/privacy).

## 5. Keine Verwendung von Cookies oder Tracking-Tools  
Wir setzen **keine Cookies** und **keine Tracking-Tools** wie Google Analytics ein.

## 6. Ihre Rechte  
Da wir keine personenbezogenen Daten verarbeiten, ergeben sich in der Regel keine Betroffenenrechte. Bei Fragen zum Datenschutz können Sie sich dennoch gerne an uns wenden.

---

**Stand: April 2025**  

    `;
const DSGVO_en = `
# Privacy Policy

## 1. General Information  
We take the protection of your personal data seriously. This website does not collect any personal data and does not offer interactive features such as forms or user accounts.

## 2. Responsible Entity  
**Esther Ratsch and Jörg Schultz GbR**  
Am Mühlschutz 2  
97348 Rödelsee  
Germany  
Email: [Joerg.Schultz@tier-wohl-team.de](mailto:Joerg.Schultz@tier-wohl-team.de)

## 3. Hosting  
This website is hosted on servers provided by **Amazon Web Services (AWS)**. AWS automatically logs technical data such as IP addresses and access times. These server logs are used solely for technical security and are not combined with other data sources.

## 4. Embedded Content from Third Parties  
Our website includes **embedded YouTube videos**. When you access a page with an embedded video, YouTube may collect information about your visit. For details, please refer to the [Google Privacy Policy](https://policies.google.com/privacy).

## 5. No Use of Cookies or Tracking Tools  
We do **not** use cookies or tracking tools such as Google Analytics.

## 6. Your Rights  
Since we do not process personal data, there are typically no data subject rights applicable. However, you are welcome to contact us if you have any questions regarding data protection.

---

**Effective Date: April 2025**  

    `;
export const DSGVO = {"de": DSGVO_de, "en": DSGVO_en};